// ── series-preview-collection: read-only preview rows (not yet created) ───

import { useMemo } from "react";
import { useCollection, type CollectionColumnDef, type UseCollectionResult } from "@vjal/ui";

import type { CoachingOperationResult } from "../../../services/coaching-dtos";
import { orDash } from "../sessions-helpers";

export type SeriesPreviewRow = {
  id: string;
  title: string;
  starts_at: string;
} & Record<string, unknown>;

export function toSeriesPreviewRows(result: CoachingOperationResult | null): SeriesPreviewRow[] {
  const rows = result?.row_results ?? [];
  return rows.map((row, index) => ({
    id: String(row.id ?? row.index ?? index),
    title: String(row.title ?? `Session ${index + 1}`),
    starts_at: String(row.starts_at ?? "")
  }));
}

export function buildSeriesPreviewCollectionColumns(): CollectionColumnDef<SeriesPreviewRow>[] {
  return [
    {
      id: "title",
      header: "Session",
      sortable: true,
      sortAccessor: (row) => row.title,
      priority: 1,
      cell: (row) => row.title
    },
    {
      id: "starts_at",
      header: "Starts",
      sortable: true,
      sortAccessor: (row) => row.starts_at,
      priority: 2,
      cell: (row) => orDash(row.starts_at)
    }
  ];
}

export const SERIES_PREVIEW_PAGE_SIZE = 50;

export function useSeriesPreviewCollection(rows: SeriesPreviewRow[]): UseCollectionResult<SeriesPreviewRow> {
  const columns = useMemo(() => buildSeriesPreviewCollectionColumns(), []);

  return useCollection<SeriesPreviewRow>({
    mode: "client",
    rows,
    columns,
    pageSize: SERIES_PREVIEW_PAGE_SIZE,
    urlSync: false,
    getRowKey: (row) => row.id
  });
}